<template>
  <div ref="layout" class="page-query">
    <TableQuery title="产品主数据批导" :tools="false">
      <el-form inline class="form" size="mini" label-width="100px">
        <el-row>
          <el-col :span="8">
            <el-form-item class="widget-view" label="导入类型">
              <el-select
                v-model="conditions.templateCode"
                placeholder="请选择"
                type="select"
                size="mini"
                clearable
                @change="tableData = []"
              >
                <el-option
                  v-for="item in selectTypes"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="16" class="download">
            <el-dropdown @command="downloadTemplate">
              <div class="tempDownload">
                <img src="@/assets/images/excel@3x.png" alt="">
                <span class="el-dropdown-link">
                  模版下载
                </span>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  :command="{ type: 'productDataBasicImport', filename: '产品基本信息模板' }"
                >产品基本信息模板下载</el-dropdown-item>
                <el-dropdown-item
                  :command="{ type: 'productdataPlanImport',filename: '产品计划属性模板' }"
                >产品计划属性模板下载</el-dropdown-item>
                <el-dropdown-item
                  :command="{ type: 'productDataStatisticalImport',filename: '产品统计属性模板' }"
                >产品统计属性模板下载</el-dropdown-item>
                <el-dropdown-item
                  :command="{ type: 'productDataYxdyImport',filename: '产品营销单元模板' }"
                >产品营销单元模板下载</el-dropdown-item>
                <el-dropdown-item
                  :command="{ type: 'productCanceYxdyImport',filename: '产品营销单元批量删除模板' }"
                >产品营销单元批量删除模板下载</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-col>
        </el-row>
      </el-form>
    </TableQuery>

    <div class="table-container">
      <template v-if="conditions.templateCode === 'productDataBasicImport'">
        <TableCommon title="基本字段" :custome-config="() => vxeShowCustom('xTable')">
          <template #button>
            <table-button
              v-for="btn in gridOptions.buttons"
              :key="btn.label"
              :name="btn.icon"
              :tip="btn.label"
              @click="tableEvent(btn, 'xTable')"
            />
          </template>
          <vxe-grid
            ref="xTable"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            :show-overflow="true"
            height="auto"
            max-height="500"
            align="center"
            size="mini"
            :empty-render="{ name: 'NotData' }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="tableData"
          />
        </TableCommon>
      </template>
      <template v-if="conditions.templateCode === 'productdataPlanImport'">
        <TableCommon title="计划属性" :custome-config="() => vxeShowCustom('xTable2')">
          <template #button>
            <table-button
              v-for="btn in gridOptions1.buttons"
              :key="btn.label"
              :name="btn.icon"
              :tip="btn.label"
              @click="tableEvent(btn, 'xTable2')"
            />
          </template>
          <vxe-grid
            ref="xTable2"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            :show-overflow="true"
            height="auto"
            max-height="500"
            align="center"
            size="mini"
            :empty-render="{ name: 'NotData' }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions1.columns"
            :data="tableData"
          />
        </TableCommon>
      </template>
      <template v-if="conditions.templateCode === 'productDataStatisticalImport'">
        <TableCommon title="统计属性" :custome-config="() => vxeShowCustom('xTable3')">
          <template #button>
            <table-button
              v-for="btn in gridOptions2.buttons"
              :key="btn.label"
              :name="btn.icon"
              :tip="btn.label"
              @click="tableEvent(btn, 'xTable3')"
            />
          </template>
          <vxe-grid
            ref="xTable3"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            :show-overflow="true"
            height="auto"
            max-height="500"
            align="center"
            size="mini"
            :empty-render="{ name: 'NotData' }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions2.columns"
            :data="tableData"
          />
        </TableCommon>
      </template>
      <template v-if="conditions.templateCode === 'productDataYxdyImport'">
        <TableCommon title="营销单元" :custome-config="() => vxeShowCustom('xTable4')">
          <template #button>
            <table-button
              v-for="btn in gridOptions3.buttons"
              :key="btn.label"
              :name="btn.icon"
              :tip="btn.label"
              @click="tableEvent(btn, 'xTable4')"
            />
          </template>
          <vxe-grid
            ref="xTable4"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            :show-overflow="true"
            height="auto"
            max-height="500"
            align="center"
            size="mini"
            :empty-render="{ name: 'NotData' }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions3.columns"
            :data="tableData"
          />
        </TableCommon>
      </template>
      <template v-if="conditions.templateCode === 'productCanceYxdyImport'">
        <TableCommon title="营销单元" :custome-config="() => vxeShowCustom('xTable5')">
          <template #button>
            <table-button
              v-for="btn in gridOptions4.buttons"
              :key="btn.label"
              :name="btn.icon"
              :tip="btn.label"
              @click="tableEvent(btn, 'xTable5')"
            />
          </template>
          <vxe-grid
            ref="xTable5"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            :show-overflow="true"
            height="auto"
            max-height="500"
            align="center"
            size="mini"
            :empty-render="{ name: 'NotData' }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions4.columns"
            :data="tableData"
          />
        </TableCommon>
      </template>
    </div>
  </div>
</template>
<script>
import { apiExportExcelTemplate, apiExcelImport, apiGetExcelImportData } from '@/api/common'
import { getToken } from '@/utils/auth'
import { DOWNLOAD_API } from '@/api/baseUrl'
import { saveProduct, apiProductDetail, saveProductDel } from '@/api/sap/client-sap'

export default {
  data() {
    return {
      conditions: {
        templateCode: 'productDataBasicImport',
        batchNumber: ''
      },
      selectTypes: [
        {
          id: 'productDataBasicImport',
          name: '产品基本信息批导'
        },
        {
          id: 'productDataStatisticalImport',
          name: '产品统计属性批导'
        },
        {
          id: 'productdataPlanImport',
          name: '产品计划属性批导'
        },
        {
          id: 'productDataYxdyImport',
          name: '产品营销单元批导'
        },
        {
          id: 'productCanceYxdyImport',
          name: '产品营销单元批量删除'
        }
      ],
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      tableData: [],
      // 基本字段
      gridOptions: {
        buttons: [
          {
            label: '导入',
            style: 'primary',
            icon: 'import',
            type: 'custom',
            code: 'import'
          },
          {
            label: '产品基本信息保存',
            style: 'primary',
            icon: 'save',
            type: 'custom',
            code: 'save'
          }
        ],
        columns: [
          // { field: 'ICON', title: '状态', width: 120 },
          { field: 'PRODUCT_ID', title: '产品ID', width: 120 },
          { field: 'SHORT_TEXT', title: '产品描述', width: 120 },
          { field: 'SHORT', title: '产品简称', width: 120 },
          { field: 'CHFL', title: '存货分类', width: 120 },
          { field: 'BASE_UOM', title: '单位', width: 120 },
          { field: 'ONUMB', title: '老编码', width: 120 },
          { field: 'NORMS', title: '显示规格', width: 120 },
          { field: 'DEGREE', title: '度数', width: 120 },
          { field: 'KBETR', title: '价格', width: 120 },
          { field: 'HZPS', title: '盒装瓶数', width: 120 },
          { field: 'XZHS', title: '箱装盒数', width: 120 },
          { field: 'ISBAR', title: '是否条形码', width: 120 },
          { field: 'BCODE', title: '条形码', width: 120 },
          { field: 'CAPTY', title: '容量', width: 120 },
          { field: 'NUMBR', title: '编号', width: 120 },
          { field: 'F_PRODUCTID', title: '产品变更自', width: 120 },
          { field: 'PCATE', title: '产品分类', width: 120 },
          { field: 'ISPEJ', title: '是否配额酒', width: 120 },
          { field: 'PECYCLE', title: '配额酒周期', width: 120 },
          { field: 'NRATE', title: '配额内外比例(内)', width: 140 },
          { field: 'WRATE', title: '配额内外比例(外)', width: 140 },
          { field: 'RESERVED1', title: '预留项1', width: 120 },
          { field: 'RESERVED2', title: '预留项2', width: 120 },
          { field: 'RESERVED6', title: '预留项6', width: 120 },
          { field: 'RESERVED7', title: '预留项7', width: 120 },
          { field: 'DELETE', title: '归档标识', width: 120 }
        ]
      },
      // 计划属性
      gridOptions1: {
        buttons: [
          {
            label: '导入',
            style: 'primary',
            icon: 'import',
            type: 'custom',
            code: 'import'
          },
          {
            label: '产品计划属性保存',
            style: 'primary',
            icon: 'save',
            type: 'custom',
            code: 'save'
          }
        ],
        columns: [
          // { field: 'ICON', title: '状态' },
          { field: 'PRODUCT_ID', title: '产品ID' },
          { field: 'POCYCLE', title: '包材采购周期（天）' },
          { field: 'POWARNING', title: '包材安全预警量（件）' },
          { field: 'FFLAG', title: '全流程标识' }
        ],
        data: []
      },
      // 统计属性
      gridOptions2: {
        buttons: [
          {
            label: '导入',
            style: 'primary',
            icon: 'import',
            type: 'custom',
            code: 'import'
          },
          {
            label: '产品统计属性保存',
            style: 'primary',
            icon: 'save',
            type: 'custom',
            code: 'save'
          }
        ],
        columns: [
          // { field: 'ICON', title: '状态', width: 120 },
          { field: 'PRODUCT_ID', title: '产品ID', width: 120 },
          { field: 'BRAND_BQ', title: '品牌(BQ)', width: 120 },
          { field: 'BCATE', title: '大类', width: 120 },
          { field: 'MCATE', title: '中类', width: 120 },
          { field: 'SCATE', title: '小类', width: 120 },
          { field: 'YCATE', title: '月报分类', width: 120 },
          { field: 'BRAND', title: '品牌（生产计划）', width: 140 },
          { field: 'CMADE', title: '是否定制', width: 120 },
          { field: 'ISEPT', title: '是否出口', width: 120 },
          { field: 'NUMBR', title: '编号', width: 120 },
          { field: 'RESERVED3', title: '预留项3', width: 120 },
          { field: 'RESERVED4', title: '预留项4', width: 120 },
          { field: 'RESERVED5', title: '预留项5', width: 120 },
          { field: 'RESERVED8', title: '预留项8', width: 120 },
          { field: 'RESERVED9', title: '预留项9', width: 120 },
          { field: 'RESERVED10', title: '预留项10', width: 120 }
        ],
        data: []
      },
      // 营销单元
      gridOptions3: {
        buttons: [
          {
            label: '导入',
            style: 'primary',
            icon: 'import',
            type: 'custom',
            code: 'import'
          },
          {
            label: '产品营销单元保存',
            style: 'primary',
            icon: 'save',
            type: 'custom',
            code: 'save'
          }
        ],
        columns: [
          // { field: 'ICON', title: '状态' },
          { field: 'PRODUCT_ID', title: '产品ID' },
          { field: 'SOBID', title: '营销单元' }
        ],
        data: []
      },
      // 营销单元批量删除
      gridOptions4: {
        buttons: [
          {
            label: '导入',
            style: 'primary',
            icon: 'import',
            type: 'custom',
            code: 'import'
          },
          {
            label: '保存',
            style: 'primary',
            icon: 'save',
            type: 'custom',
            code: 'save'
          }
        ],
        columns: [
          // { field: 'ICON', title: '状态' },
          { field: 'PRODUCT_ID', title: '产品ID' },
          { field: 'ZZFLD00001H', title: '营销单元' }
        ],
        data: []
      }
    }
  },
  methods: {
    // 模板下崽
    async downloadTemplate({ type, filename }) {
      const res = await apiExportExcelTemplate(type)

      if (res?.status !== 0) {
        return
      }

      const url = `${DOWNLOAD_API()}/attachment/downFileByTmpdir.ajax?file=${
        res.data.file
      }&authToken=${getToken()}&fileName=${filename}`
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.target = '_blank'
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
    tableEvent(btn, xTable) {
      switch (btn.code) {
        case 'import':
          this.handleImportExcel(xTable)
          break
        case 'save':
          if (xTable === 'xTable5') {
            this.saveProductDel()
          } else {
            this.handleSaveImportExcel()
          }
          break
      }
    },
    async saveProductDel() {
      const params = {
        mode: 'D',
        product: this.tableData
      }
      const res = await saveProductDel(params)
      if (res.msgtype === 'S') {
        return this.$message.success(res.message)
      } else {
        return this.$message.warning(res.message)
      }
    },
    // 导入excel
    async handleImportExcel(xTable) {
      this.$refs[xTable]
        .readFile({
          types: ['xlsx']
        })
        .then(async resp => {
          const { files } = resp
          const formData = new FormData()
          Array.from(files).forEach(file => {
            formData.append('file', file)
          })
          const params = {
            formData,
            templateCode: this.conditions.templateCode
          }
          const res = await apiExcelImport(params)
          if (res?.status === 1) {
            this.conditions.batchNumber = res.data
            this.handleQueryImportExcel(res.data)
          }
        })
    },
    // 查询导入excel数据
    async handleQueryImportExcel() {
      const params = { ...this.conditions, page: 1, pagesize: 100 }
      const res = await apiGetExcelImportData(params)

      for (const item of res.data.Rows) {
        Object.keys(item).forEach(key => {
          item[this.toLineAndUp(key)] = item[key]
          delete item[key]
        })
      }
      params.DELETE = params.DELETE1
      this.tableData = res.data.Rows
      // sap 数据检查
      // this.checkData(res.data.Rows, 'X')
    },
    async checkData(data, check) {
      const types = {
        'productDataBasicImport': 'INFO',
        'productDataYxdyImport': 'YXDY',
        'productDataStatisticalImport': 'STATISTICAL',
        'productdataPlanImport': 'PLAN'
      }
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        mode: types[this.conditions.templateCode],
        check: check,
        [types[this.conditions.templateCode]]: data
      }
      const res = await 2
      if (res.MSGTYPE === 'S') {
        this.tableData = res.DATA[types[this.conditions.templateCode]]
        if (!check) {
          return this.$message.success(res.MESSAGE)
        }
      }
    },
    // 保存
    async handleSaveImportExcel() {
      //
      if (!this.tableData.length) return this.$message.warning('无有效数据！')
      const types = {
        'productDataBasicImport': 'data1',
        'productDataYxdyImport': 'data4',
        'productDataStatisticalImport': 'data3',
        'productdataPlanImport': 'data2'
      }
      const params = {
        model: 'B',
        partner: this.$store.getters.role.USER_BP
      }
      params[types[this.conditions.templateCode]] = this.tableData
      const res = await saveProduct(params)
      if (res.msgtype === 'S') {
        return this.$message.success(res.message)
      } else {
        return this.$message.warning(res.message)
      }
    },
    // 驼峰转成下划线并且大写
    toLineAndUp(str = '') {
      return str.replace(/([A-Z])/g, '_$1').toUpperCase()
    }
  }
}
</script>

<style lang="scss" scoped>
.download {
  text-align: right;
  line-height: 36px;
  font-size: 14px;
  .tempDownload {
    display: flex;
    align-items: center;
    img {
      display: inline-block;
      width: 14px;
      height: 14px;
      margin-right: 8px;
    }
    span {
      font-size: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/product-manage/productDataImp.vue